<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择销售订单"
      width="1200px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="sd/so"
        @select="salesOrderSelect"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="销售单号" prop="salesOrderNo">
            <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入销售单号" clearable/>
          </el-form-item>
          <el-form-item label="合同号" prop="customerContractNo">
            <el-input v-model.trim="filter.customerContractNo" placeholder="请输入合同号" clearable/>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model.trim="filter.status" placeholder="请选择订单状态">
              <el-option label="草稿" :value="10" disabled/>
              <el-option label="已提交" :value="20"/>
              <el-option label="作废" :value="999" disabled/>
              <el-option label="退单" :value="12" disabled/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          salesOrderNo: "",
          customerContractNo: "",
          status: 20,
        },
        columns: [
          {
            title: "销售单号",
            key: "salesOrderNo",
            width: 140,
            align: "center",
          },
          {
            title: "合同号",
            key: "customerContractNo",
            width: 200,
          },
          {
            title: "客户名称",
            key: "customerName",
          },
          {
            title: "要求交期",
            key: "deliveryDate",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      salesOrderSelect(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
